import React from "react";
import {
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ContactInfo from "./ContactInfo";
import PersonalInfoPolicyXs from "./small-ui/PersonalInfoPolicyXs";

const PersonalInfoPolicy = ({ isXs, id }) => {
  const { t } = useTranslation();
  if (isXs) return <PersonalInfoPolicyXs id={id} />;
  return (
    <Paper elevation={1} sx={{ p: { md: 4, xs: 2 }, mb: 4 }} id={id}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <i className="fas fa-shield-alt fa-2x" style={{ color: "#0c4d96" }}></i>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ ml: 2 }}
        >
          {t("privacy-policy.personal-info-policy.title")}
        </Typography>
      </Box>

      <Typography paragraph>
        {t("privacy-policy.personal-info-policy.intro")}
      </Typography>

      <List>
        {t("privacy-policy.personal-info-policy.items", {
          returnObjects: true,
        }).map((item, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <i
                className="fas fa-chevron-right"
                style={{ color: "#0c4d96" }}
              ></i>
            </ListItemIcon>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>

      <Box sx={{ mt: 3, mb: 3 }}>
        <Typography sx={{ textAlign: "right" }}>
          {t("privacy-policy.personal-info-policy.footer.company")}
        </Typography>
        <Typography sx={{ textAlign: "right" }}>
          {t("privacy-policy.personal-info-policy.footer.dates")}
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Typography paragraph>
        {t("privacy-policy.personal-info-policy.contact")}
      </Typography>

      <ContactInfo />
    </Paper>
  );
};

export default PersonalInfoPolicy;
